// src/reduxStore/modules/tenants/selectors.js

export const selectTenants = state => state.tenants.tenants;
export const selectTenantDetails = state => state.tenants.tenantDetails;
export const selectTenantConversations = state => state.tenants.tenantConversations;
export const selectCurrentTenant = state => state.tenants.currentTenant;
export const selectTenantEnableUpload = state => state.tenants.tenantEnableUpload;
export const selectUserExplicitlyEnabledUpload = state => state.tenants.userExplicitlyEnabledUpload;

// Default page info to prevent new object creation on every render
const DEFAULT_PAGE_INFO = {
  pageNum: 1,
  pageSize: 100,
  sortOrder: 1,
  sortBy: ['FirstName', 'LastName']
};

// Simple memoized selector - returns the same reference when pageInfo exists
export const selectTenantsPageInfo = state => state.tenants.pageInfo || DEFAULT_PAGE_INFO;

export const selectSelectedCustomers = state => state.tenants.selectedCustomers || [];
export const selectSearchedCustomers = state => state.tenants.searchedCustomers || []; 